// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"78f63e94","393":"2853cbb5"}[chunkId] + ".css";
};